/* eslint-disable */
import axios from "axios";

export default {
    methods: {
        /**
            * Service que serve para autenticar o usuário
            * @param { { authCode: String, codigoUnimed: String } } params - objeto que contém o authCode e o código da unimed 
            * @return { Promise< { Body: { login: String, userId: Number, email: String, nomeUsuario: String, papeis: Array<String>, unimedSelecionada: String, unimedSelecionadaNome: String, usuarioUnimedLegado: String, usuarioUnimedId: Number }, Header: { authorization: String }> }
        */
        getLogin (params) {
            return axios.get(this.CriarUrl({ resource: '/login', params }, { adicionarAuth: true }))
        }
    }
}